import { render, staticRenderFns } from "./NavCategoriesLayout.vue?vue&type=template&id=5e8a8724&scoped=true&"
import script from "./NavCategoriesLayout.vue?vue&type=script&lang=js&"
export * from "./NavCategoriesLayout.vue?vue&type=script&lang=js&"
import style0 from "./NavCategoriesLayout.vue?vue&type=style&index=0&id=5e8a8724&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8a8724",
  null
  
)

export default component.exports